import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {UserContext} from "../../auth/Auth";

class AuthorizationRequired extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {children} = this.props;
        const userContext = UserContext.get();

        if (userContext)
            return children;

        return '';
    }
}

export default AuthorizationRequired;


// WEBPACK FOOTER //
// ./src/utils/components/AuthorizationRequired.js